import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";

export default function VerifyCertificate() {
  const { code } = useParams();
  const [result, setResult] = useState(null);
  useEffect(() => { api.get(`/certificates/verify/${code}`).then(r => setResult(r.data)); }, [code]);

  if (!result) return <div className="p-10 text-center text-muted2 font-mono text-sm">Vérification…</div>;
  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="verify-page">
      <div className="glass rounded-3xl p-10 text-center">
        <ShieldCheck className="w-10 h-10 text-gold-700 mx-auto mb-3" />
        <div className="text-xs uppercase tracking-widest text-gold-700 font-mono">Vérification d'authenticité</div>
        <div className="font-mono text-sm text-muted2 mt-1">{code}</div>

        {result.valid ? (
          <>
            <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-success/15 border border-success/40 text-success text-sm" data-testid="verify-result-valid">
              <CheckCircle2 className="w-4 h-4" /> Certificat authentique
            </div>
            <h1 className="font-display text-3xl md:text-4xl text-ink-900 mt-6">{result.user_full_name}</h1>
            <p className="text-muted2 mt-2">a validé la certification</p>
            <h2 className="font-display text-xl text-gold-700-gradient mt-2">{result.certification_title}</h2>
            <p className="text-muted2 text-sm mt-1">{result.category_name}</p>
            <div className="mt-6 text-sm text-muted2">
              Délivré le <span className="text-ink-900">{new Date(result.issued_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span> par E.C.S
            </div>
          </>
        ) : (
          <div className="mt-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-danger/15 border border-danger/40 text-danger text-sm" data-testid="verify-result-invalid">
              <XCircle className="w-4 h-4" /> Certificat introuvable
            </div>
            <p className="text-muted2 mt-4 text-sm">Le code saisi ne correspond à aucun certificat valide dans notre base de données.</p>
          </div>
        )}
        <Link to="/" className="inline-block mt-8 text-xs text-muted2 hover:text-gold-700-700">← Retour à l'accueil</Link>
      </div>
    </div>
  );
}
